<div mat-dialog-content>
    {{ message }}
</div>
<div mat-dialog-actions>
    <button mat-flat-button (click)="onNoClick()">{{ cancel }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ confirm }}</button>
</div>   